module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.259cb4ce.svg";